import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'

import { SiretPendingAssignmentTopBar } from '@features/invoicingSettings/elements/SiretPendingAssignment'
import { UserOrganizationContextProvider } from '@modules-deprecated/app/organization'

import { queryClient } from '../../config/queryClient'
import { EmberNavigate, EmberRouterContextProvider } from '../../contexts/emberRouterContext'
import { ThemeProvider } from '../../contexts/themeProvider'

const MODULE_NAME = 'siret-pending-assignment-top-bar-module'

class SiretPendingAssignmentTopBarWebComponent extends DOMModel {
  @byAttrVal('organizationId') organizationId: string
  @registerEvent('navigate') navigate: Function
}

interface SiretPendingAssignmentTopBarModuleProps {
  onNavigate: EmberNavigate
  organizationId: string
}

const SiretPendingAssignmentTopBarModule = ({
  onNavigate,
  organizationId,
}: SiretPendingAssignmentTopBarModuleProps): ReactElement => (
  <ThemeProvider>
    <QueryClientProvider client={queryClient}>
      <EmberRouterContextProvider onNavigate={onNavigate}>
        <UserOrganizationContextProvider organizationId={organizationId}>
          <ModalContextProvider>
            <SiretPendingAssignmentTopBar />
          </ModalContextProvider>
        </UserOrganizationContextProvider>
      </EmberRouterContextProvider>
    </QueryClientProvider>
  </ThemeProvider>
)

const SiretPendingAssignmentTopBarCustomElement = createCustomElement(
  SiretPendingAssignmentTopBarModule,
  SiretPendingAssignmentTopBarWebComponent,
  'element',
)

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, SiretPendingAssignmentTopBarCustomElement)

export default SiretPendingAssignmentTopBarCustomElement
